import React from "react";
import { EXCEPTIONS_TEXT, ACCENT_IMAGE } from "@/content/veguk";
import { EXCEPTIONS } from "@/constants/testIds";
import { AlertCircle, Wine } from "lucide-react";

export const Exceptions = () => {
  return (
    <section
      id="exceptions"
      data-testid={EXCEPTIONS.root}
      className="py-24 lg:py-32 bg-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <span className="veg-overline">Exceptions</span>
          <h2 className="font-serif-display mt-4 text-4xl sm:text-5xl text-[#2E5C46] leading-[1.05]">
            By-products to be aware of.
          </h2>
          <p className="mt-5 text-[#4A5D4E] leading-relaxed">
            {EXCEPTIONS_TEXT.intro}
          </p>
          <div className="mt-8 relative overflow-hidden rounded-lg border border-[#D1C9B9]">
            <img
              src={ACCENT_IMAGE}
              alt="Fresh vegetables on a wooden surface"
              className="w-full h-72 object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7 space-y-5">
          {EXCEPTIONS_TEXT.items.map((it) => (
            <article
              key={it.term}
              className="veg-card-hover bg-white border border-[#D1C9B9] rounded-lg p-7 flex gap-5"
            >
              <div className="shrink-0 mt-1 text-[#A34E36]">
                <AlertCircle size={22} />
              </div>
              <div>
                <h3 className="font-serif-display text-2xl text-[#2C352D]">
                  {it.term}
                </h3>
                <p className="mt-2 text-[#4A5D4E] leading-relaxed text-sm">
                  {it.body}
                </p>
              </div>
            </article>
          ))}

          <div className="bg-[#EAE3D9]/70 border border-[#D1C9B9] rounded-lg p-7 space-y-3">
            {EXCEPTIONS_TEXT.notes.map((note, idx) => (
              <p
                key={idx}
                className="text-sm text-[#2C352D] leading-relaxed flex items-start gap-3"
              >
                {idx === EXCEPTIONS_TEXT.notes.length - 1 ? (
                  <Wine size={16} className="mt-1 shrink-0 text-[#A34E36]" />
                ) : (
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#2E5C46] shrink-0" />
                )}
                <span>{note}</span>
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
